import { PointType } from './point';
import { RectType } from './rect';

export class CoordsUtils {
  static isPointNearRectBoundaries(
    point: PointType,
    rect: RectType,
    threshold: number = 0
  ) {
    return (
      point.y < rect.y + threshold ||
      point.y > rect.y + rect.height - threshold ||
      point.x < rect.x + threshold ||
      point.x > rect.x + rect.width - threshold
    );
  }

  static isPointInsideRect(point: PointType, rect: RectType) {
    return (
      rect.x < point.x &&
      rect.y < point.y &&
      rect.x + rect.width > point.x &&
      rect.y + rect.height > point.y
    );
  }

  static isRectWidthBiggerThan(rectA: RectType, rectB: RectType): boolean {
    return rectA.width > rectB.width;
  }

  static isRectHeightBiggerThan(rectA: RectType, rectB: RectType): boolean {
    return rectA.height > rectB.height;
  }

  static isRectBiggerThan(rectA: RectType, rectB: RectType): boolean {
    return (
      CoordsUtils.isRectWidthBiggerThan(rectA, rectB) &&
      CoordsUtils.isRectHeightBiggerThan(rectA, rectB)
    );
  }

  static isRectSomeAxisBiggerThan(rectA: RectType, rectB: RectType): boolean {
    return (
      CoordsUtils.isRectWidthBiggerThan(rectA, rectB) ||
      CoordsUtils.isRectHeightBiggerThan(rectA, rectB)
    );
  }
}
